const widgets = [
    'widgetAlarm'
];

export default {
    widgets
} 